import React from 'react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import BaseMainLayout from './baseLayout';
const MailLayoutLocale = ({ children, l2cCrmSidebarMenuExtra }) => (React.createElement(ConfigProvider, { locale: zhCN },
    React.createElement(BaseMainLayout, { l2cCrmSidebarMenuExtra: l2cCrmSidebarMenuExtra }, children)));
export default MailLayoutLocale;
